import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');
  const inputBackground = useColorModeValue('gray.50', 'navy.900');

  const validStatusBg = useColorModeValue('green.100', 'green.500');
  const invalidStatusBg = useColorModeValue('red.100', 'red.500');
  const validStatusColor = useColorModeValue('green.600', 'green.900');
  const invalidStatusColor = useColorModeValue('red.600', 'red.900');

  const getStatusColors = (isValid) => ({
    bg: isValid ? validStatusBg : invalidStatusBg,
    color: isValid ? validStatusColor : invalidStatusColor,
  });

  return {
    backgroundCardColor,
    borderColor,
    textColor,
    inputBackground,
    getStatusColors,
  };
};
